import { configureStore } from '@reduxjs/toolkit';
import { rootReducers } from '../reducers';
// Remove this import as it's not needed
// import { thunk } from 'redux-thunk';

const store = configureStore({
  reducer: rootReducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: true,
    }), // Remove the .concat(thunk)
  devTools: true,
});

// Add type definitions for better TypeScript support
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;